export default __webpack_public_path__ + "static/media/1799.16eadd91.png";